<template>
    <div class="alert-bg">
        <div class="alert-box">
        <img src="../../assets/img/logo-bg1.png" width="200px">
        <h3 class="textCenter">با عرض پوزش، سرویس‌های خلافی خودرو در حال حاضر غیرفعال هستند.</h3>
        </div>
    </div>
</template>

<script>
export default {
  name: "CarFines-Services"
}
</script>
